module.exports = __webpack_public_path__ + "img/tn1.25c26db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/TamiNadu/tn1.jpg
// module id = 1733
// module chunks = 1